import { FormEvent, useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import confirmacaoImg from '../../assets/img/confirmacao.png'
import contratoImg from '../../assets/img/contrato.png'
import erroImg from '../../assets/img/erroFechar.png'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { cepMascara, converterNumero, cpfCnpjMascara, descriptografarDado, moedaMascara, telefoneMascara, validarCpfCnpj } from '../../helpers'
import { ModalOrganizacaoDados } from '../../interfaces/organizacao'
import buscarCep from '../../services/cep'
import { contratarSistema } from '../../services/contratarSistema'
import { atualizarOrganizacao } from '../../services/organizacao'
import { dadosUsuario } from '../../services/usuarios'
import '../../styles/modal.css'
import ModalAlerta from '../ModalAlerta'
import Notificacoes from '../Notificacoes'
import { Button, Loader } from '../Styles'
import './modalcontratarsistema.css'


function ModalContratarSistema({ organizacao }: ModalOrganizacaoDados) {

    const { exibirModal, atualizarDados } = useContext(ModalEstadoContext)

    const [clienteCnpjCpf] = useState(organizacao?.cnpjCpf)
    const [clienteNomeFantasia, setClienteNomeFantasia] = useState(organizacao?.nomeFantasia)
    const [clienteRazaoSocial, setClienteRazaoSocial] = useState(organizacao?.razaoSocial)
    const [clienteTelefone, setClienteTelefone] = useState(organizacao?.telefone)
    const [clienteEmail, setClienteEmail] = useState(organizacao?.email)
    const [clienteRua, setClienteRua] = useState(organizacao?.rua)
    const [clienteNumero, setClienteNumero] = useState(organizacao?.numero)
    const [clienteBairro, setClienteBairro] = useState(organizacao?.bairro)
    const [clienteComplemento, setClienteComplemento] = useState(organizacao?.complemento)
    const [clienteCep, setClienteCep] = useState(organizacao?.cep)
    const [clienteCidade, setClienteCidade] = useState(organizacao?.cidade)
    const [clienteEstado, setClienteEstado] = useState(organizacao?.estado)
    const [responsavelCpf, setResponsavelCpf] = useState('')
    const [responsavelNome, setResponsavelNome] = useState('')
    const [responsavelTelefone, setResponsavelTelefone] = useState('')
    const [responsavelEmail, setResponsavelEmail] = useState('')
    const [responsavelDataNascimento, setResponsavelDataNascimento] = useState('')
    const [responsavelRua, setResponsavelRua] = useState(organizacao?.rua)
    const [responsavelNumero, setResponsavelNumero] = useState(organizacao?.numero)
    const [responsavelBairro, setResponsavelBairro] = useState(organizacao?.bairro)
    const [responsavelComplemento, setResponsavelComplemento] = useState(organizacao?.complemento)
    const [responsavelCep, setResponsavelCep] = useState(organizacao?.cep)
    const [responsavelCidade, setResponsavelCidade] = useState(organizacao?.cidade)
    const [responsavelEstado, setResponsavelEstado] = useState(organizacao?.estado)
    const [dadosOrganizacao, setDadosOrganizacao] = useState(true)
    const [dadosResponsavel, setDadoResponsavel] = useState(false)
    const [dadosContratacao, setDadosContratacao] = useState(false)
    const [usuariosAdicionais, setUsuariosAdicionais] = useState(0)
    const [valorTotal, setValorTotal] = useState(0)
    const [form, setForm] = useState(true)
    const [processando, setProcessando] = useState(false)
    const [confirmacao, setConfirmacao] = useState(false)
    const [erro, setErro] = useState(false)
    const [cpfInvalido, setCpfInvalido] = useState(false)
    const [dadosIncompletos, setDadosIncompletos] = useState(false)

    const changeClienteCep = async (e: any) => {

        const valor = cepMascara(e.target.value)
        setClienteCep(valor)

        const cepLimpo = valor.replace(/\D/g, "")

        if (cepLimpo.length !== 8) return

        try {

            const dados = await toast.promise(buscarCep(valor), {
                pending: "Buscando dados do endereço, por favor aguarde...",
                error: "CEP do cliente inválido"
            })

            setClienteRua(dados.logradouro)
            setClienteBairro(dados.bairro)
            setClienteCidade(dados.localidade)
            setClienteEstado(dados.estado.toLowerCase())

        } catch {

            toast.error("CEP do cliente inválido")
            setClienteRua("")
            setClienteBairro("")
            setClienteCidade("")
            setClienteEstado("")
        }
    }

    const changeResponsavelCep = async (e: any) => {

        const valor = cepMascara(e.target.value)
        setResponsavelCep(valor)

        const cepLimpo = valor.replace(/\D/g, "")

        if (cepLimpo.length !== 8) return

        try {

            const dados = await toast.promise(buscarCep(valor), {
                pending: "Buscando dados do endereço, por favor aguarde...",
                error: "CEP do responsável inválido"
            })

            setResponsavelRua(dados.logradouro)
            setResponsavelBairro(dados.bairro)
            setResponsavelCidade(dados.localidade)
            setResponsavelEstado(dados.estado.toLowerCase())

        } catch {

            toast.error("CEP do responsável inválido")
            setResponsavelRua("")
            setResponsavelBairro("")
            setResponsavelCidade("")
            setResponsavelEstado("")
        }
    }

    function ocultarModal() {

        return exibirModal()
    }

    function ocultarModalAlerta() {

        setForm(true)
        return setErro(false)
    }

    const avancarVoltarContratacao = () => {

        setDadosOrganizacao(!dadosOrganizacao)
        setDadoResponsavel(!dadosResponsavel)

        return
    }

    const ultimaEtapaContratacao = () => {

        setDadoResponsavel(!dadosResponsavel)
        setDadosContratacao(!dadosContratacao)
        setDadosOrganizacao(false)

        return
    }

    const validarCpf = (e: any) => {

        const validarDados = validarCpfCnpj(e.target.value)

        if (validarDados === false) {
            setCpfInvalido(true)
            setResponsavelCpf('')

            return setTimeout(() => {
                setCpfInvalido(false)
            }, 2500)
        }
    }

    useEffect(() => {

        const usuariosExtras = usuariosAdicionais

        setValorTotal(39.90 * 100 + usuariosExtras * 9.90 * 100)

        return

    }, [usuariosAdicionais])

    const contratarPlataforma = async (e: FormEvent) => {

        e.preventDefault()
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'configuracao_empresa']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if (!temPermissao) return toast.warn("Você não tem permissão para contratar um sistema.")
        setForm(false)
        setProcessando(true)

        if (responsavelNumero === undefined || responsavelNumero === null || responsavelComplemento === undefined || responsavelCep === undefined || responsavelCep === null || clienteCnpjCpf === null || clienteCnpjCpf === undefined || clienteNomeFantasia === null || clienteNomeFantasia === undefined || clienteRazaoSocial === null || clienteRazaoSocial === undefined || clienteEmail === null || clienteEmail === undefined || clienteTelefone === undefined || clienteTelefone === null || clienteNumero === null || clienteNumero === undefined || clienteComplemento === undefined || clienteCep === undefined || clienteCep === null) {
            setProcessando(false)
            setDadosIncompletos(true)

            return setTimeout(() => {
                setDadosIncompletos(false)
            }, 2500)
        }

        try {

            const payload = {
                responsavel: {
                    nome: responsavelNome,
                    cnpjCpf: responsavelCpf,
                    email: responsavelEmail,
                    telefone: responsavelTelefone,
                    dataNascimento: responsavelDataNascimento,
                    numero: responsavelNumero,
                    complemento: responsavelComplemento,
                    cep: responsavelCep,
                    rua: responsavelRua,
                    bairro: responsavelBairro,
                    cidade: responsavelCidade,
                    estado: responsavelEstado
                },
                cliente: {
                    cnpjCpf: clienteCnpjCpf,
                    nomeFantasia: clienteNomeFantasia,
                    razaoSocial: clienteRazaoSocial,
                    email: clienteEmail,
                    telefone: clienteTelefone,
                    numero: clienteNumero,
                    complemento: clienteComplemento,
                    cep: clienteCep,
                    rua: clienteRua,
                    bairro: clienteBairro,
                    cidade: clienteCidade,
                    estado: clienteEstado
                },
                usuariosAdicionais,
                valorAssinatura: converterNumero(valorTotal) / 100
            }

            const payloadAtualizarOrganizacao = {
                nomeFantasia: clienteNomeFantasia,
                razaoSocial: clienteRazaoSocial,
                email: clienteEmail,
                telefone: clienteTelefone,
                numero: clienteNumero,
                complemento: clienteComplemento,
                cep: clienteCep,
                rua: clienteRua,
                bairro: clienteBairro,
                cidade: clienteCidade,
                estado: clienteEstado
            }

            await atualizarOrganizacao(payloadAtualizarOrganizacao)

            const resposta = await contratarSistema(payload)

            if (resposta.status === 201) {
                setProcessando(false)
                atualizarDados()
                setConfirmacao(true)

                return
            }

        } catch (error: any) {
            console.log(error)
            if (error.response.status === 400) {
                setProcessando(false)
                setDadosIncompletos(true)

                return setTimeout(() => {
                    setDadosIncompletos(false)
                    setForm(true)
                }, 2500)
            }

            setProcessando(false)
            setErro(true)

            return
        }

    }

    useEffect(() => {

        const usuarioDados = async () => {

            try {

                const resposta = await dadosUsuario()

                if (resposta.status === 200) {

                    const { nome, email, telefone } = resposta.data

                    setResponsavelNome(nome)
                    setResponsavelEmail(email)
                    setResponsavelTelefone(telefone)
                }

            } catch (error) {

            }
        }

        usuarioDados()

    }, [])


    return (
        <div id='fundoModal'>
            {dadosIncompletos && <Notificacoes icone={erroImg} texto='Dados Incompletos. Veja os campos obrigatório e tente novamente' cor='erro' />}
            {cpfInvalido && <Notificacoes icone={erroImg} texto='CPF Inválido' cor='erro' />}
            {confirmacao && <ModalAlerta texto='Contratação Realizada com Sucesso. Logo Breve Você receberá o boleto para pagamento da contratação' btnTitulo='Continuar' icone={confirmacaoImg} cor='continuarSucesso' acao={ocultarModal} />}
            {erro && <ModalAlerta texto='Ocorreu um erro ao processar a solicitação. Tente Novamente' btnTitulo='Tentar Novamente' icone={erroImg} cor='continuarErro' acao={ocultarModalAlerta} />}
            {form && <section id='containerModalNovo'>
                <span id='novoContainerTitulo'>
                    <img id='adicionarModalIcone' src={contratoImg} alt='' />
                    <p>Revise seus Dados</p>
                </span>
                <form id='formModalNovo' className='formContratarSistema' onSubmit={contratarPlataforma}>
                    {dadosOrganizacao && <div>
                        <h1 className='dadosOrganizacaoContratar'>DADOS DO NEGÓCIO</h1>
                        <section>
                            <span>
                                <label>CNPJ/CPF</label>
                                <input
                                    type="text"
                                    value={clienteCnpjCpf}
                                    disabled />
                            </span>
                            <span>
                                <label htmlFor='nomeFantasiaOrganizacao'>Nome Fantasia</label>
                                <input
                                    id='nomeFantasiaOrganizacao'
                                    type="text"
                                    value={clienteNomeFantasia === null ? '' : clienteNomeFantasia}
                                    onChange={(e) => setClienteNomeFantasia(e.target.value)}
                                    required />
                            </span>
                            <span>
                                <label htmlFor='razaoSocialOrganizacao'>Razão Social</label>
                                <input
                                    id='nomeFantasiaOrganizacao'
                                    type="text"
                                    value={clienteRazaoSocial === null ? '' : clienteRazaoSocial}
                                    onChange={(e) => setClienteRazaoSocial(e.target.value)}
                                    required />
                            </span>
                        </section>

                        <section>
                            <span>
                                <label htmlFor='telefoneOrganizazao'>Telefone</label>
                                <input
                                    id='telefoneOrganizazao'
                                    type="text"
                                    value={clienteTelefone === null ? '' : clienteTelefone}
                                    onChange={(e) => setClienteTelefone(telefoneMascara(e.target.value))}
                                    required />
                            </span>
                            <span>
                                <label htmlFor='emailOrganizacao'>E-mail</label>
                                <input
                                    id='emailOrganizacao'
                                    type="email"
                                    value={clienteEmail === null ? '' : clienteEmail}
                                    onChange={(e) => setClienteEmail(e.target.value)}
                                    required />
                            </span>
                        </section>
                        <h1 className='dadosOrganizacaoContratar'>Endereço do Estabelecimento</h1>
                        <section>
                            <span>
                                <label htmlFor='cepOrganizacao'>CEP</label>
                                <input
                                    id='cepOrganizacao'
                                    type="text"
                                    value={clienteCep === null ? '' : clienteCep}
                                    maxLength={11}
                                    minLength={11}
                                    onChange={changeClienteCep}
                                    required />
                            </span>
                        </section>
                        <section>
                            <span>
                                <label htmlFor='ruaOrganizacao'>Rua</label>
                                <input
                                    id='ruaOrganizacao'
                                    type="text"
                                    value={clienteRua === null ? '' : clienteRua}
                                    onChange={(e) => setClienteRua(e.target.value)}
                                    required />
                            </span>
                            <span>
                                <label htmlFor='numeroOrganizacao'>Número</label>
                                <input
                                    id='numeroOrganizacao'
                                    type="text"
                                    value={clienteNumero === null ? '' : clienteNumero}
                                    onChange={(e) => setClienteNumero(e.target.value)}
                                    required />
                            </span>

                            <span>
                                <label htmlFor='bairroOrganizacao'>Bairro</label>
                                <input
                                    id='bairroOrganizacao'
                                    type="text"
                                    value={clienteBairro === null ? '' : clienteBairro}
                                    onChange={(e) => setClienteBairro(e.target.value)}
                                    required />
                            </span>
                            <span>
                                <label htmlFor='complementoOrganizacao'>Complemento</label>
                                <input
                                    id='complementoOrganizacao'
                                    type="text"
                                    value={clienteComplemento === null ? '' : clienteComplemento}
                                    onChange={(e) => setClienteComplemento(e.target.value)} />
                            </span>
                        </section>
                        <section>
                            <span>
                                <label htmlFor='cidadeOrganizacao'>Cidade</label>
                                <input
                                    id='cidadeOrganizacao'
                                    type="text"
                                    value={clienteCidade === null ? '' : clienteCidade}
                                    disabled />
                            </span>
                            <span>
                                <label htmlFor='estadoOrganizacao'>Estado</label>
                                <input
                                    id='responsavelEstado'
                                    type="text"
                                    value={clienteEstado === null ? '' : clienteEstado}
                                    disabled
                                />
                            </span>
                        </section>
                        <span id="botoesContainer">
                            <Button type='button' cor='cancelar' isLoading={processando} onClick={ocultarModal}>Cancelar</Button>
                            <Button type='submit' cor='salvar' isLoading={processando} onClick={avancarVoltarContratacao} disabled={processando}>
                                {!processando && 'Próxima Etapa'}
                                {processando && <Loader isLoading={processando} />}
                            </Button>
                        </span>
                    </div>}
                    {dadosResponsavel && <div>
                        <h1 className='dadosOrganizacaoContratar'>DADOS DO RESPONSÁVEL</h1>
                        <section>
                            <span>
                                <label htmlFor='responsavelCpf'>CPF</label>
                                <input
                                    id='responsavelCpf'
                                    type="text"
                                    value={responsavelCpf === null ? '' : responsavelCpf}
                                    onChange={(e) => setResponsavelCpf(cpfCnpjMascara(e.target.value))}
                                    placeholder='000.000.000 - 00'
                                    minLength={16}
                                    maxLength={16}
                                    onBlur={(e) => validarCpf(e)}
                                    required />
                            </span>
                            <span>
                                <label htmlFor='responsavelNome'>Nome Completo</label>
                                <input
                                    id='responsavelNome'
                                    type="text"
                                    value={responsavelNome === null ? '' : responsavelNome}
                                    onChange={(e) => setResponsavelNome(e.target.value)}
                                    required />
                            </span>
                        </section>
                        <section>
                            <span>
                                <label htmlFor='responsavelTelefone'>Telefone</label>
                                <input
                                    id='responsavelTelefone'
                                    type="text"
                                    placeholder='(00) 0.0000 - 0000'
                                    minLength={18}
                                    maxLength={18}
                                    value={responsavelTelefone === null ? '' : responsavelTelefone}
                                    onChange={(e) => setResponsavelTelefone(telefoneMascara(e.target.value))}
                                    required />
                            </span>
                            <span>
                                <label htmlFor='responsavelEmail'>E-mail</label>
                                <input
                                    id='responsavelEmail'
                                    type="email"
                                    value={responsavelEmail === null ? '' : responsavelEmail}
                                    onChange={(e) => setResponsavelEmail(e.target.value)}
                                    required />
                            </span>
                            <span>
                                <label htmlFor='responsavelDataNascimento'>Data de Nascimento</label>
                                <input
                                    id='responsavelDataNascimento'
                                    type="date"
                                    value={responsavelDataNascimento}
                                    onChange={(e) => setResponsavelDataNascimento(e.target.value)}
                                    required />
                            </span>
                        </section>
                        <h1 className='dadosOrganizacaoContratar'>Endereço do Responsável</h1>
                        <section>
                            <span>
                                <label htmlFor='responsavelCep'>CEP</label>
                                <input
                                    id='responsavelCep'
                                    type="text"
                                    value={responsavelCep === null ? '' : responsavelCep}
                                    minLength={11}
                                    maxLength={11}
                                    onChange={changeResponsavelCep}
                                    required/>
                            </span>
                        </section>
                        <section>
                            <span>
                                <label htmlFor='responsavelRua'>Rua</label>
                                <input
                                    type="text"
                                    value={responsavelRua === null ? '' : responsavelRua}
                                    onChange={(e) => setResponsavelRua(e.target.value)}
                                    required />
                            </span>
                            <span>
                                <label htmlFor='responsavelNumero'>Número</label>
                                <input
                                    id='responsavelNumero'
                                    type="text"
                                    value={responsavelNumero === null ? '' : responsavelNumero}
                                    onChange={(e) => setResponsavelNumero(e.target.value)}
                                    required />
                            </span>
                            <span>
                                <label htmlFor='responsavelBairro'>Bairro</label>
                                <input
                                    id='responsavelBairro'
                                    type="text"
                                    value={responsavelBairro === null ? '' : responsavelBairro}
                                    onChange={(e) => setResponsavelBairro(e.target.value)}
                                    required />
                            </span>
                            <span>
                                <label htmlFor='responsavelComplemento'>Complemento</label>
                                <input
                                    id='responsavelComplemento'
                                    type="text"
                                    value={responsavelComplemento === null ? '' : responsavelComplemento}
                                    onChange={(e) => setResponsavelComplemento(e.target.value)} />
                            </span>
                        </section>
                        <section>
                            <span>
                                <label htmlFor='responsavelCidade'>Cidade</label>
                                <input
                                    id='responsavelCidade'
                                    type="text"
                                    value={responsavelCidade === null ? '' : responsavelCidade}
                                    disabled />
                            </span>
                            <span>
                                <label htmlFor='responsavelEstado'>Estado</label>
                                <input
                                    id='responsavelEstado'
                                    type="text"
                                    value={responsavelEstado === null ? '' : responsavelEstado}
                                    disabled
                                />
                            </span>
                        </section>
                        <span id="botoesContainer">
                            <Button type='button' cor='cancelar' isLoading={processando} onClick={avancarVoltarContratacao}>Voltar</Button>
                            <Button type='button' cor='salvar' isLoading={processando} onClick={ultimaEtapaContratacao}>Próxima Etapa</Button>
                        </span>
                    </div>}
                    {dadosContratacao && <div>
                        <h1 className='dadosOrganizacaoContratar'>DADOS DA CONTRATAÇÃO</h1>
                        <section>
                            <span>
                                <label htmlFor='dadosContratacao'>Valor Base</label>
                                <input
                                    id='dadosContratacao'
                                    type="text"
                                    value={'R$ 39,90'}
                                    disabled
                                    required />
                            </span>
                            <span>
                                <label htmlFor='usuariosAdicionais'>Usuários Adicionais</label>
                                <input
                                    id='usuariosAdicionais'
                                    type="number"
                                    min={0}
                                    value={usuariosAdicionais}
                                    onChange={(e) => setUsuariosAdicionais(Number(e.target.value))}
                                    required />
                            </span>
                            <span>
                                <label htmlFor='valorTotalContratado'>Valor Final da Contratação</label>
                                <input
                                    id='valorTotalContratado'
                                    type="text"
                                    value={moedaMascara(valorTotal)}
                                    disabled
                                    required />
                            </span>
                        </section>


                        <span id="botoesContainer">
                            <Button type='button' cor='cancelar' isLoading={processando} onClick={ultimaEtapaContratacao}>Voltar</Button>
                            <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                                {!processando && 'Finalizar Contratação'}
                                {processando && <Loader isLoading={processando} />}
                            </Button>
                        </span>
                    </div>}
                </form>
            </section>}
        </div>
    )
}

export default ModalContratarSistema
